import api from '@/api';
import {
  SpedDocument,
  SpedDocumentCreateRequest,
  SpedDocumentEditRequest,
  SpedDocumentInutilization,
  SpedDocumentInutilizationListRequest,
  SpedDocumentInvoice,
  SpedDocumentInvoiceListRequest,
  SpedDocumentListRequest,
  SpedDocumentListResponse,
  SpedDocumentManageImports,
  SpedDocumentPurchase,
  SpedDocumentPurchaseListRequest,
} from './sped-documents.types';

const path = '/sped/v1/sped/sped-document';

export default {
  async documentsList(params?: SpedDocumentListRequest) {
    const result = (await api.get(path, params)) as unknown;
    return result as SpedDocumentListResponse;
  },

  async documentRemove(id: number) {
    const result = (await api.remove(`${path}/${id}`, {}, null)) as unknown;
    return result as void;
  },

  async documentCreate(payload: SpedDocumentCreateRequest) {
    const result = (await api.post(path, payload)) as unknown;
    return result as void;
  },

  async documentEdit({ spedDocumentId, ...payload }: SpedDocumentEditRequest) {
    const result = (await api.put(
      `${path}/${spedDocumentId}`,
      payload,
      null,
    )) as unknown;
    return result as void;
  },

  async documentDetail(id?: number) {
    const result = (await api.get(`${path}/${id}`, null)) as unknown;
    return result as SpedDocument;
  },

  async manageImports(data: SpedDocumentManageImports) {
    const result = (await api.patch(
      `${path}/${data.spedDocumentId}/manage-invoices-purchases`,
      data.items,
      null,
    )) as unknown;
    return result as void;
  },

  async invoices({
    spedDocumentId,
    ...params
  }: SpedDocumentInvoiceListRequest) {
    const result = (await api.get(
      `${path}/${spedDocumentId}/invoices`,
      params,
    )) as unknown;
    return result as SpedDocumentInvoice[];
  },

  async purchases({
    spedDocumentId,
    ...params
  }: SpedDocumentPurchaseListRequest) {
    const result = (await api.get(
      `${path}/${spedDocumentId}/purchases`,
      params,
    )) as unknown;
    return result as SpedDocumentPurchase[];
  },

  async inutilizations({
    spedDocumentId,
    ...params
  }: SpedDocumentInutilizationListRequest) {
    const result = (await api.get(
      `${path}/${spedDocumentId}/inutilization`,
      params,
    )) as unknown;
    return result as SpedDocumentInutilization[];
  },

  async sendToPlugStorage(spedDocumentId: number) {
    const result = (await api.post(
      `${path}/${spedDocumentId}/send-to-plug-storage`,
      {},
    )) as unknown;
    return result as void;
  },
};
